import { Accordion, Col, Container, Row } from 'react-bootstrap';
import { motion } from 'motion/react';
import digitalData from '../../data/digitalData.json';
import img1 from "../../assets/marketing_strategy.png";

const Process = () => {
  const accordionVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: { duration: 0.5, delay: index * 0.1 }
    })
  }

  const imageVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  }

  return (
    <section className='section-lg' id='features'>
      <Container>
        <Row className="text-center mb-5">
          <Col lg={8} className="mx-auto text-center">
            <div className="service-heading mb-3">
              <motion.h6 className="underline-after text-center position-relative z-0"
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
              >
                <span className="position-relative z-1 bg-white text-primary px-3">Our Process</span>
              </motion.h6>
              <motion.h2 className="d-block text-gradiant text-center fw-semibold display-5"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
              >
                How We Drive Results
              </motion.h2>
            </div>
            <motion.p className="lead text-secondary"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              Our proven methodology ensures we deliver consistent results for your business.
            </motion.p>
          </Col>
        </Row>
        <Row className="align-items-center g-5">
          <Col lg={6}>
            <motion.div className="ratio ratio-16x9 rounded-4 overflow-hidden shadow-lg"
              variants={imageVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              whileHover={{ scale: 1.02, transition: { duration: 0.3 } }}
            >
              <img src={img1} className="w-100 h-100 object-fit-cover" alt="Digital Marketing Strategy" />
            </motion.div>
          </Col>

          <Col lg={6}>
            <motion.h3 className="fw-bold mb-4 text-success"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              Our 4-Step Process
            </motion.h3>
            <Accordion defaultActiveKey="0" flush>
              {digitalData.process.map((step, index) => (
                <motion.div className="mb-3"
                  key={step.id}
                  variants={accordionVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  custom={index}
                >
                  <Accordion.Item eventKey={step.eventKey} className="shadow-sm rounded-3">
                    <Accordion.Header className="fw-semibold rounded-3">
                      <span className="badge bg-success bg-gradient me-3">{step.badge}</span> {step.title}
                    </Accordion.Header>
                    <Accordion.Body className="text-secondary">
                      {step.description}
                    </Accordion.Body>
                  </Accordion.Item>
                </motion.div>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Process;
